// Original DB values (for backward compatibility)
export const assessmentTypeDbValues = [
  '5 Day', // already exists
  'Interim Payment', // already exists
  '14-Day', // New DB value
  '30-Day', // New DB value
  '60-Day', // New DB value
  '90-Day', // New DB value
  'Unscheduled', // New DB value
  'Admission', // New DB value
  'Discharge', // already exists
  'Quarterly', // already exists
  'Annual', // already exists
  'Significant Change', // already exists
];

// New UI labels
export const assessmentTypeLabels = [
  '5-Day (PPS)',
  '14-Day (PPS)',
  '30-Day (PPS)',
  '60-Day (PPS)',
  '90-Day (PPS)',
  'Unscheduled (PPS)',
  'Interim Payment (PPS)',
  'Admission (OBRA)',
  'Quarterly (OBRA)',
  'Annual (OBRA)',
  'Significant Change (OBRA)',
  'Discharge (PPS)',
];

// Mapping from DB values to UI labels
export const assessmentTypeMapping: Record<string, string> = {
  '5 Day': '5-Day (PPS)',
  'Interim Payment': 'Interim Payment (PPS)',
  '14-Day': '14-Day (PPS)', // New DB value
  '30-Day': '30-Day (PPS)', // New DB value
  '60-Day': '60-Day (PPS)', // New DB value
  '90-Day': '90-Day (PPS)', // New DB value
  'Unscheduled': 'Unscheduled (PPS)', // New DB value
  'Admission': 'Admission (OBRA)', 
  'Discharge': 'Discharge (PPS)',
  'Quarterly': 'Quarterly (OBRA)',
  'Annual': 'Annual (OBRA)',
  'Significant Change': 'Significant Change (OBRA)',
};

// Reverse mapping from UI labels to DB values
export const assessmentTypeReverseMapping: Record<string, string> = {
  '5-Day (PPS)': '5 Day',
  'Interim Payment (PPS)': 'Interim Payment',
  '14-Day (PPS)': '14-Day', // New DB value for 14-Day
  '30-Day (PPS)': '30-Day', // New DB value for 30-Day
  '60-Day (PPS)': '60-Day', // New DB value for 60-Day
  '90-Day (PPS)': '90-Day', // New DB value for 90-Day
  'Unscheduled (PPS)': 'Unscheduled', // New DB value for Unscheduled
  'Admission (OBRA)': 'Admission', // New DB value for Admission
  'Quarterly (OBRA)': 'Quarterly',
  'Annual (OBRA)': 'Annual',
  'Significant Change (OBRA)': 'Significant Change',
  'Discharge (PPS)': 'Discharge',
};

// Helper function to get UI label from DB value
export const getAssessmentTypeLabel = (dbValue: string): string => {
  return assessmentTypeMapping[dbValue] || dbValue;
};

// Helper function to get DB value from UI label
export const getAssessmentTypeDbValue = (uiLabel: string): string => {
  return assessmentTypeReverseMapping[uiLabel] || uiLabel;
};

// For dropdown display (UI labels)
export const assessmentTypeList = assessmentTypeLabels;

// Nursing CMG: map 3-digit code to HIPPS letter for display (e.g. ES3 -> A, show "ES3 - A")
const nursingToHippsMap: Record<string, string> = {
  ES3: 'A',
  ES2: 'B',
  ES1: 'C',
  HDE2: 'D',
  HDE1: 'E',
  HBC2: 'F',
  HBC1: 'G',
  LDE2: 'H',
  LDE1: 'I',
  LBC2: 'J',
  LBC1: 'K',
  CDE2: 'L',
  CDE1: 'M',
  CBC2: 'N',
  CA2: 'O',
  CBC1: 'P',
  CA1: 'Q',
  BAB2: 'R',
  BAB1: 'S',
  PDE2: 'T',
  PDE1: 'U',
  PBC2: 'V',
  PA2: 'W',
  PBC1: 'X',
  PA1: 'Y',
};

/** Display label for Nursing CMG in view/edit (code + letter, e.g. "ES3 - A"). DB remains 3-digit. */
export const getNursingDisplayValue = (code: string): string => {
  if (!code) return code;
  const hippsChar = nursingToHippsMap[code];
  return hippsChar ? `${code} - ${hippsChar}` : code;
};